/* eslint-disable @typescript-eslint/no-explicit-any */

import { color } from 'asserts/styles/colors';
import { usePercentagesFromArray } from './usePercentagesFromArray';

const useLineForDoughnut = (type?: string) => {
  const getCustomLine = (chart: any) => {
    const ctx = chart.ctx;
    const { width, height } = chart;

    chart.data.datasets.forEach((dataset: any, datasetIndex: number) => {
      const meta = chart.getDatasetMeta(datasetIndex);

      meta.data.forEach((element: any, index: number) => {
        const model = element;
        const { x, y } = model.tooltipPosition();

        if (dataset.data[index] === 0) {
          return;
        }

        const halfWidth = width / 2;
        const halfHeight = height / 2;

        const label = chart.data.labels[index];
        const data: number = dataset.data[index];

        const getPercentagesFromArray = usePercentagesFromArray();

        const dataPercentages = getPercentagesFromArray(dataset.data)[index];

        const lineX = x >= halfWidth ? x + 30 : x - 30;
        const lineY = y >= halfHeight ? y + 30 : y - 30;
        const extraLine = x >= halfWidth ? 20 : -20;

        ctx.beginPath();
        ctx.moveTo(x, y);

        if (dataPercentages >= 10) {
          ctx.lineTo(lineX, lineY);
          ctx.lineTo(lineX + extraLine, lineY);
        }

        ctx.strokeStyle = 'rgba(255, 255, 255, 0.80)';
        ctx.stroke();

        const lineHeight = 16;
        const textPosition = x >= halfWidth ? 'left' : 'right';
        const whiteSpaceLineToText = x >= halfWidth ? 9 : -9;
        const text = type === 'half' ? `${data?.toLocaleString()}명` : `${label}\n${data?.toLocaleString()}명`;
        const linesBreak = text.split('\n');

        ctx.textAlign = textPosition;
        ctx.textBaseline = 'middle';
        ctx.fillStyle = `${color.white08}`;
        ctx.font = '13px Noto Sans KR';

        linesBreak.forEach((line, index) => {
          if (dataPercentages >= 10) {
            ctx.fillText(line, lineX + extraLine + whiteSpaceLineToText, lineY + index * lineHeight);
          }
        });

        if (dataPercentages >= 10) {
          ctx.beginPath();
          ctx.font = '500 13px Noto Sans KR';
          ctx.fillStyle = `${color.white}`;

          // lineHeight * 2, * 3이 적용되지않음으로 + 여러번 사용
          const yPosition =
            type === 'half'
              ? lineY + datasetIndex * lineHeight + lineHeight
              : lineY + datasetIndex * lineHeight + lineHeight + lineHeight;

          ctx.fillText(`${dataPercentages.toFixed(1)}%`, lineX + extraLine + whiteSpaceLineToText, yPosition);
        }

        const addCircleToLine = (ctx: CanvasRenderingContext2D, x: number, y: number) => {
          ctx.beginPath();
          ctx.arc(x, y, 3, 0, 2 * Math.PI);
          ctx.fillStyle = `${color.white08}`;
          ctx.fill();
          ctx.stroke();
        };

        if (dataPercentages >= 10) {
          // 도넛 차트 내부, 외부 점
          addCircleToLine(ctx, x, y);
          addCircleToLine(ctx, lineX + extraLine, lineY);
        }
      });
    });
  };

  return getCustomLine;
};

export default useLineForDoughnut;
